
   import { butter } from "../plugins/buttercms";
   import calDynamicLandingPage from '../components/cal-dynamic-landing-page.vue';
   export default {
      components: { calDynamicLandingPage },
      name: "rewards",
      data() {
         return {
         pageData: {},
         metaTags: {},
         }
      },
      async fetch() {
         try {
         const page = await butter(this.$config).page.retrieve("*", "rewards",
         {
            locale: this.$i18n.getLocaleCookie(),
            timeout: 10000
         }
         );
            this.pageData = page?.data.data.fields;
            this.metaTags = this.pageData.seo;
         } catch(error) {
            console.error(error);
         }
      },
   }
